var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    enableBackground: "new 0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M170.1,212.3h-118c-13.9,0-25.3-11.3-25.3-25.3V35.3C26.9,21.3,38.2,10,52.1,10h118c13.9,0,25.3,11.3,25.3,25.3V187C195.4,200.9,184.1,212.3,170.1,212.3z M52.1,26.9c-4.6,0-8.4,3.8-8.4,8.4V187c0,4.6,3.8,8.4,8.4,8.4h118c4.6,0,8.4-3.8,8.4-8.4V35.3c0-4.6-3.8-8.4-8.4-8.4H52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M203.9,246H77.4c-4.6,0-8.4-3.8-8.4-8.4c0-4.7,3.8-8.4,8.4-8.4h126.4c4.6,0,8.4-3.8,8.4-8.4V60.6c0-4.6,3.8-8.4,8.4-8.4c4.7,0,8.4,3.8,8.4,8.4v160.1C229.1,234.7,217.8,246,203.9,246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M136.4,77.4H69c-4.6,0-8.4-3.8-8.4-8.4s3.8-8.4,8.4-8.4h67.4c4.7,0,8.4,3.8,8.4,8.4S141.1,77.4,136.4,77.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M153.3,119.6H69c-4.6,0-8.4-3.8-8.4-8.4c0-4.6,3.8-8.4,8.4-8.4h84.3c4.7,0,8.4,3.8,8.4,8.4C161.7,115.8,158,119.6,153.3,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M153.3,161.7H69c-4.6,0-8.4-3.8-8.4-8.4c0-4.7,3.8-8.4,8.4-8.4h84.3c4.7,0,8.4,3.8,8.4,8.4C161.7,158,158,161.7,153.3,161.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson);
export default __webpack_public_path__ + "static/media/lesson.b79d4802c8ccbd076d5bcacfd5ca5a2d.svg";
export { ForwardRef as ReactComponent };